import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import { getFaqs, deleteFaqs } from "../../../apis/faqs";
import { useNavigate } from "react-router-dom";
import striptags from "striptags";

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [faqsId, setfaqsId] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const res = await getFaqs();
      setFaqs(res.result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Faqs:", error);
      setLoading(false);
    }
  };

  const getFaqId = async (id) => {
    setfaqsId(id);
  };

  const DeleteFaqs = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Faq?",
    );
    if (isConfirmed) {
      await deleteFaqs(id);
      setLoading(true);
      fetchFaqs();
    }
  };
  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
    },

    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => text.substring(0, 60),
      width: "40%",
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <span
          dangerouslySetInnerHTML={{ __html: striptags(text).substring(0, 70) }}
        ></span>
      ), // Render description without HTML tags
      width: "40%",
    },

    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={`/addFaqs/${record.id}`}
              onClick={() => getFaqId(record.id)}
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => DeleteFaqs(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "40%",
    },
  ];

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link to="/AddFaqs" className="btn btn-primary mb-3">
              Add Faqs
            </Link>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <Table
                columns={columns}
                dataSource={faqs?.length > 0 ? faqs : []}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
